<template>
  <div>
    <h1>About</h1>
    Demo page for webpack chunks
  </div>
</template>

<script>
export default {
  name: 'TermsAndPrivacyPage'
}
</script>
